import { useNavigate } from "react-router-dom";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "./ui/table";
import { formatDate } from "../lib/dateUtils";

const STATUS_STYLE = {
  "Fully Matched": "bg-midnight-black text-clean-white",
  "No Registrations": "bg-soft-gray text-midnight-black/60",
};

/** Compact "next sessions" table shared by the Photographer dashboard — click a row to manage that session. */
export const DashboardUpcomingTable = ({ sessions }) => {
  const navigate = useNavigate();

  if (sessions.length === 0) {
    return (
      <p className="font-medium text-midnight-black/60" data-testid="dashboard-no-upcoming-sessions">
        No upcoming sessions on the calendar.
      </p>
    );
  }

  return (
    <div className="border border-soft-gray rounded-2xl overflow-hidden overflow-x-auto" data-testid="dashboard-upcoming-table">
      <Table>
        <TableHeader>
          <TableRow className="border-soft-gray">
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Date</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Session</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">City</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Registered</TableHead>
            <TableHead className="text-[10px] font-bold uppercase tracking-wide">Matching</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {sessions.map((s) => (
            <TableRow
              key={s.id}
              onClick={() => navigate(`/dashboard/sessions/${s.id}/manage`)}
              className="border-soft-gray cursor-pointer hover:bg-warm-white"
              data-testid={`dashboard-upcoming-row-${s.id}`}
            >
              <TableCell className="font-bold text-xs whitespace-nowrap">{formatDate(s.session_date)}</TableCell>
              <TableCell className="font-bold text-xs">{s.title}</TableCell>
              <TableCell className="text-xs whitespace-nowrap">{s.city}, {s.state}</TableCell>
              <TableCell className="text-xs">{s.registered_count}/{s.capacity}</TableCell>
              <TableCell>
                <span className={`text-[10px] font-bold uppercase tracking-wide px-2 py-1 rounded-full whitespace-nowrap ${STATUS_STYLE[s.matching_status] || "bg-stranger-orange text-clean-white"}`}>
                  {s.matching_status}
                </span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
